/**
 * Mobile store listing URLs for download badges (e.g. email verification success).
 * Sourced from https://rampver.com/app/ — update here if the marketing page changes.
 */
export const GOOGLE_PLAY_LISTING_URL =
  "https://play.google.com/store/apps/details?id=com.rampver.myapp";

export const APPLE_APP_STORE_LISTING_URL =
  "https://apps.apple.com/us/app/rampver-online/id6758603004";

export const HUAWEI_APP_GALLERY_LISTING_URL =
  "https://appgallery.huawei.com/app/C117220467";
